<script>
	export let menu;
	export let company_data;

	import NavBar from "./NavBar.svelte";
	import LandingPage from "./components/LandingPage.svelte";
	import MonteSeuPrato from "./components/MonteSeuPrato.svelte";
	import Separador from "./components/Separador.svelte";
	import PratosPrincipais from "./components/PratosPrincipais.svelte";
	import Acompanhamentos from "./components/Acompanhamentos.svelte";
	import Sobremesas from "./components/Sobremesas.svelte";
	import Footer from "./components/Footer.svelte";

	import WhatsAppWidget from "./components/WhatsAppWidget.svelte";

	let pratos_principais = menu.pratos_principais;
	let acompanhamentos = menu.acompanhamentos;
	let sobremesas = menu.sobremesas;

	let company_name = company_data.name;
</script>

<svelte:head>
	<title>{company_name}</title>
	<link href="https://fonts.googleapis.com/css?family=Poppins:100,200,400,300,500,600,700" rel="stylesheet"> 

	<link rel="stylesheet" href="css/awesome/font-awesome.min.css" />
	<link rel="stylesheet" href="css/bootstrap/bootstrap.min.css" />
</svelte:head>

<main>
	<NavBar {company_data}/>
	<LandingPage {company_data}/>
	<MonteSeuPrato {company_data}/>
	<Separador />
	<div class="container">
		<PratosPrincipais {pratos_principais} />
		<Acompanhamentos {acompanhamentos} />
		<Sobremesas {sobremesas} />
	</div>
	<Footer {company_data}/>
	<WhatsAppWidget {company_data}/>
</main>
